import { useMsal } from "@azure/msal-react";
import { createLogger } from "logging";
import React, { PropsWithChildren, useMemo } from "react";

import { AuthenticationContext, defaultScopes, IAuthentication } from "./AuthenticationContext";
import { AuthLoading } from "./AuthLoading";

const logger = createLogger("AuthenticatedProvider");

export const AuthenticatedProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { accounts, instance } = useMsal();

  const authentication = useMemo<IAuthentication | undefined>(() => {
    if (accounts.length === 0 || !instance) {
      return undefined;
    }

    const account = accounts[0];
    return {
      currentUser: {
        name: account.name || account.username,
        username: account.username,
        id: account.localAccountId,
      },
      acquireTokenSilent: async (scopes?: string[] | undefined) => {
        scopes = scopes && scopes.length > 0 ? scopes : defaultScopes;
        logger.trace("acquireTokenSilent(): requesting for", scopes);

        const response = await instance.acquireTokenSilent({ scopes, account });
        const accessToken = response.accessToken;
        logger.trace("acquireTokenSilent(): Got", `${accessToken.substring(0, 10)}...`);

        return accessToken;
      },
      logout: () => {
        logger.debug("logout(): Logging out");
        instance.logoutRedirect();
      },
    };
  }, [accounts, instance]);

  if (!authentication) {
    return <AuthLoading />;
  }

  return <AuthenticationContext.Provider value={authentication}>{children}</AuthenticationContext.Provider>;
};
